import { useEffect, useRef, useState } from 'react';

function FileInputDropZone({
  onFileSelect,
  accept = '*',
  label = 'Arrastra y suelta un archivo aquí',
  hint = 'o haz clic para seleccionar',
  multiple = false,

  forwardedRef = null,
  onSetFileName,
}) {
  const fileInputRef = useRef(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const [fileName, setFileName] = useState('');

  const handleClick = () => {
    if (forwardedRef?.current) {
      return forwardedRef?.current?.click();
    }

    fileInputRef?.current?.click();
  };

  const handleFiles = (files) => {
    if (!files || files.length === 0) return;

    const file = multiple ? files : files[0];

    if (!multiple) {
      setFileName(file.name);
      onSetFileName?.(file.name);
    } else {
      setFileName(`${files.length} archivos seleccionados`);
      onSetFileName?.(`${files.length} archivos seleccionados`);
    }

    if (onFileSelect) {
      onFileSelect(file);
    }
  };

  const handleInputChange = (e) => {
    handleFiles(e.target.files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    handleFiles(e.dataTransfer.files);
  };

  useEffect(() => {
    if (forwardedRef.current.value) {
      setFileName(null);
    }
  }, [forwardedRef]);

  return (
    <div className="file-drop-wrapper">
      <input
        type="file"
        ref={forwardedRef || fileInputRef}
        className="file-input-hidden"
        accept={accept}
        multiple={multiple}
        onChange={handleInputChange}
      />

      <div
        className={`drop-zone ${isDragOver ? 'drag-over' : ''}`}
        onClick={handleClick}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <div className="drop-zone__content">
          <div className="drop-zone__title">{label}</div>

          <div className={fileName ? 'drop-zone__filename' : 'drop-zone__hint'}>{fileName || hint}</div>
        </div>
      </div>
    </div>
  );
}

export default FileInputDropZone;
